<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import UserApi from '@/api/system/user'

  export default {
    name: 'app',
    provide () { // 注册一个方法
      return {
        reload: this.reload,
        showQuDao: true
      }
    },
    data () {
      return {
        isRouterAlive: true
      }
    },
    created () {
      if (window.location.host !== 'test-emcp.qudao51.com' && window.location.host !== 'www.qudao51.com') {
        this.showQuDao = false
      }
      if (window.location.host === 'localhost:8030') {
        this.showQuDao = true
      }
      // 获取登陆信息
      UserApi.getInfo(response => {
        let status = response.data.code
        let body = response.data.data || {}

        if (status === '200') {
          this.$store.dispatch('login', {user: body})
          this.$cookie.set('_qd_emcp.l_s', 'true')
        } else {
          this.$cookie.delete('_qd_emcp.l_s')
          // this.$router.push('/')
        }
      })
    },
    methods: {
      reload () {
        this.isRouterAlive = false
        this.$nextTick(() => {
          this.isRouterAlive = true
        })
      }
    },
    mounted () {
      // if (!this.showQuDao) {
      //   let links = document.getElementsByTagName('link')
      //   for (let i = 0; i < links.length; i++) {
      //     let link = links[i].rel.toLowerCase()
      //     if (link.indexOf('shortcut icon') > -1) {
      //       links[i].href = ''
      //       document.title = '祺祥网络'
      //       console.log(links[i])
      //       break
      //     }
      //   }
      // }
      // document.title = '客户管理系统'
    }
  }
</script>

<style lang="scss">
  @import "assets/styles/env";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
    height: 100%;
    min-width: 1300px;
    .app-loading {
      background-color: blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue